import { FC, ReactNode } from "react";
import { HomePageContextProvider } from "@/contexts/HomePageContext/HomePageContextProvider";
import { DarkModeContextProvider } from "@/contexts/DarkModeContext/DarkModeContextProvider";
import { LoadingContextProvider } from "@/contexts/LoadingContext/LoadingContextProvider";
import { AppColorsContextProvider } from "@/contexts/AppColors/AppColorsContextProvider";

type Props = {
  children: ReactNode;
};

export const ContextProvider: FC<Props> = ({ children }) => {
  return (
    <DarkModeContextProvider>
      <AppColorsContextProvider>
        <LoadingContextProvider>
          <HomePageContextProvider>{children}</HomePageContextProvider>
        </LoadingContextProvider>
      </AppColorsContextProvider>
    </DarkModeContextProvider>
  );
};
